export const bengaliFlashcards = {
  categories: [
    {
      bn: "নমস্কার",
      rm: "Nomoshkar",
      en: "Hello / Greetings (formal)",
    },
    {
      bn: "সালাম",
      rm: "Salam",
      en: "Hello / Greetings (Muslim)",
    },
    {
      bn: "কেমন আছেন?",
      rm: "Kemon achen?",
      en: "How are you? (formal)",
    },
    {
      bn: "কেমন আছো?",
      rm: "Kemon acho?",
      en: "How are you? (informal)",
    },
    {
      bn: "আমি ভালো আছি",
      rm: "Ami bhalo achi",
      en: "I am fine",
    },
    {
      bn: "ধন্যবাদ",
      rm: "Dhonnobad",
      en: "Thank you",
    },
    {
      bn: "অনেক ধন্যবাদ",
      rm: "Onek dhonnobad",
      en: "Thank you very much",
    },
    {
      bn: "স্বাগতম",
      rm: "Swagotom",
      en: "Welcome",
    },
    {
      bn: "কিছু না",
      rm: "Kichu na",
      en: "You're welcome / It's nothing",
    },
    {
      bn: "মাফ করবেন",
      rm: "Maaf korben",
      en: "Excuse me / Sorry",
    },
    {
      bn: "দয়া করে",
      rm: "Doya kore",
      en: "Please",
    },
    {
      bn: "হ্যাঁ",
      rm: "Hyan",
      en: "Yes",
    },
    {
      bn: "না",
      rm: "Na",
      en: "No",
    },
    {
      bn: "ঠিক আছে",
      rm: "Thik ache",
      en: "Okay / Alright",
    },
    {
      bn: "আমি বুঝতে পারছি না",
      rm: "Ami bujhte parchi na",
      en: "I don't understand",
    },
    {
      bn: "আপনি কি ইংরেজি বলেন?",
      rm: "Apni ki ingreji bolen?",
      en: "Do you speak English? (formal)",
    },
    {
      bn: "তুমি কি ইংরেজি বলো?",
      rm: "Tumi ki ingreji bolo?",
      en: "Do you speak English? (informal)",
    },
    {
      bn: "এটা কি?",
      rm: "Eta ki?",
      en: "What is this?",
    },
    {
      bn: "এটার দাম কত?",
      rm: "Etar daam koto?",
      en: "How much is this?",
    },
    {
      bn: "কোথায়?",
      rm: "Kothay?",
      en: "Where?",
    },
    {
      bn: "টয়লেট কোথায়?",
      rm: "Toilet kothay?",
      en: "Where is the toilet?",
    },
    {
      bn: "রেলস্টেশন কোথায়?",
      rm: "Relstation kothay?",
      en: "Where is the train station?",
    },
    {
      bn: "এয়ারপোর্ট কোথায়?",
      rm: "Airport kothay?",
      en: "Where is the airport?",
    },
    {
      bn: "সাহায্য করুন!",
      rm: "Sahajjo korun!",
      en: "Help!",
    },
    {
      bn: "আমার সাহায্য দরকার",
      rm: "Amar sahajjo দরকার",
      en: "I need help",
    },
    {
      bn: "আমি হারিয়ে গেছি",
      rm: "Ami hariye gechi",
      en: "I am lost",
    },
    {
      bn: "আপনি কি আমায় সাহায্য করতে পারেন?",
      rm: "Apni ki amay sahajjo korte paren?",
      en: "Can you help me? (formal)",
    },
    {
      bn: "তুমি কি আমায় সাহায্য করতে পারো?",
      rm: "Tumi ki amay sahajjo korte paro?",
      en: "Can you help me? (informal)",
    },
    {
      bn: "ধীরে বলুন",
      rm: "Dhire bolun",
      en: "Speak slowly",
    },
    {
      bn: "আবার বলুন",
      rm: "Abar bolun",
      en: "Say it again",
    },
    {
      bn: "আমি অসুস্থ",
      rm: "Ami osustho",
      en: "I am sick",
    },
    {
      bn: "আমার ডাক্তার দরকার",
      rm: "Amar daktar দরকার",
      en: "I need a doctor",
    },
    {
      bn: "এটা খুব দামি",
      rm: "Eta khub daami",
      en: "This is too expensive",
    },
    {
      bn: "কিছু কমাতে পারবেন?",
      rm: "Kichu komate parben?",
      en: "Can you lower the price? (formal)",
    },
    {
      bn: "কিছু কমাতে পারবে?",
      rm: "Kichu komate parbe?",
      en: "Can you lower the price? (informal)",
    },
    {
      bn: "আমি এটা নিতে চাই",
      rm: "Ami eta nite chai",
      en: "I want to take this",
    },
    {
      bn: "আমার এটা লাগবে না",
      rm: "Amar eta lagbe na",
      en: "I don't need this",
    },
    {
      bn: "আমার নাম...",
      rm: "Amar naam...",
      en: "My name is...",
    },
    {
      bn: "আপনার নাম কি?",
      rm: "Apnar naam ki?",
      en: "What is your name? (formal)",
    },
    {
      bn: "তোমার নাম কি?",
      rm: "Tomar naam ki?",
      en: "What is your name? (informal)",
    },
    {
      bn: "আমি ভালো আছি, ধন্যবাদ",
      rm: "Ami bhalo achi, dhonnobad",
      en: "I am fine, thank you",
    },
    {
      bn: "ভালো",
      rm: "Bhalo",
      en: "Good",
    },
    {
      bn: "খুব ভালো",
      rm: "Khub bhalo",
      en: "Very good",
    },
    {
      bn: "খারাপ",
      rm: "Kharap",
      en: "Bad",
    },
    {
      bn: "শুভ সকাল",
      rm: "Shubho sokal",
      en: "Good morning",
    },
    {
      bn: "শুভ দুপুর",
      rm: "Shubho dupur",
      en: "Good afternoon",
    },
    {
      bn: "শুভ সন্ধ্যা",
      rm: "Shubho sondha",
      en: "Good evening",
    },
    {
      bn: "শুভ রাত্রি",
      rm: "Shubho ratri",
      en: "Good night",
    },
    {
      bn: "বিদায়",
      rm: "Biday",
      en: "Goodbye",
    },
    {
      bn: "পরে দেখা হবে",
      rm: "Pore dekha hobe",
      en: "See you later",
    },
    {
      bn: "ডানে",
      rm: "Daane",
      en: "Right",
    },
    {
      bn: "বামে",
      rm: "Baame",
      en: "Left",
    },
    {
      bn: "সোজাসুজি",
      rm: "Sojasuji",
      en: "Straight",
    },
    {
      bn: "উপরে",
      rm: "Upore",
      en: "Up",
    },
    {
      bn: "নীচে",
      rm: "Niche",
      en: "Down",
    },
    {
      bn: "কাছে",
      rm: "Kache",
      en: "Near",
    },
    {
      bn: "দূরে",
      rm: "Dure",
      en: "Far",
    },
    {
      bn: "আজ",
      rm: "Aaj",
      en: "Today",
    },
    {
      bn: "আগামীকাল",
      rm: "Agamikal",
      en: "Tomorrow",
    },
    {
      bn: "গতকাল",
      rm: "Gotokal",
      en: "Yesterday",
    },
    {
      bn: "এখন",
      rm: "Ekhon",
      en: "Now",
    },
    {
      bn: "পরে",
      rm: "Pore",
      en: "Later",
    },
    {
      bn: "সকাল",
      rm: "Sokal",
      en: "Morning",
    },
    {
      bn: "দুপুর",
      rm: "Dupur",
      en: "Afternoon",
    },
    {
      bn: "সন্ধ্যা",
      rm: "Sondha",
      en: "Evening",
    },
    {
      bn: "রাত",
      rm: "Raat",
      en: "Night",
    },
    {
      bn: "জল",
      rm: "Jol",
      en: "Water",
    },
    {
      bn: "খাবার",
      rm: "Khabar",
      en: "Food",
    },
    {
      bn: "চা",
      rm: "Cha",
      en: "Tea",
    },
    {
      bn: "কফি",
      rm: "Coffee",
      en: "Coffee",
    },
    {
      bn: "বিয়ার",
      rm: "Biyar",
      en: "Beer",
    },
    {
      bn: "এটা কি নিরামিষ?",
      rm: "Eta ki niramish?",
      en: "Is this vegetarian?",
    },
    {
      bn: "আমার খিদে পেয়েছে",
      rm: "Amar khide peyeche",
      en: "I am hungry",
    },
    {
      bn: "আমার তেষ্টা পেয়েছে",
      rm: "Amar teshta peyeche",
      en: "I am thirsty",
    },
    {
      bn: "কত সময় লাগবে?",
      rm: "Koto shomoy lagbe?",
      en: "How much time will it take?",
    },
    {
      bn: "পাসপোর্ট",
      rm: "Passport",
      en: "Passport",
    },
    {
      bn: "ভিসা",
      rm: "Visa",
      en: "Visa",
    },
    {
      bn: "হোটেল",
      rm: "Hotel",
      en: "Hotel",
    },
    {
      bn: "ঘর",
      rm: "Ghor",
      en: "Room",
    },
    {
      bn: "আমি একটা ঘর বুক করতে চাই",
      rm: "Ami ekta ghor book korte chai",
      en: "I want to book a room",
    },
    {
      bn: "এটা খুব ভালো",
      rm: "Eta khub bhalo",
      en: "This is very good",
    },
    {
      bn: "কোনো সমস্যা নেই",
      rm: "Kono shomossha nei",
      en: "No problem",
    },
    {
      bn: "অভিনন্দন!",
      rm: "Abhinondon!",
      en: "Congratulations!",
    },
    {
      bn: "শুভকামনা",
      rm: "Shubhokamona",
      en: "Best wishes",
    },
    {
      bn: "আনন্দ করুন",
      rm: "Anondo korun",
      en: "Have fun",
    },
    {
      bn: "বসুন",
      rm: "Bosun",
      en: "Sit down (formal)",
    },
    {
      bn: "বোসো",
      rm: "Boso",
      en: "Sit down (informal)",
    },
    {
      bn: "দাঁড়ান",
      rm: "Daran",
      en: "Stand up (formal)",
    },
    {
      bn: "দাঁড়াও",
      rm: "Darao",
      en: "Stand up (informal)",
    },
    {
      bn: "চুপ করুন",
      rm: "Chup korun",
      en: "Be quiet (formal)",
    },
    {
      bn: "চুপ করো",
      rm: "Chup koro",
      en: "Be quiet (informal)",
    },
  ],
};
